module.exports = __webpack_public_path__ + "static/img/mask-1.612b97d.png";


//////////////////
// WEBPACK FOOTER
// ./static/ugc/creation/filter/mask-1.png
// module id = NI+b
// module chunks = 1